module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-panel', {
    staticClass: "panelBackground",
    attrs: {
      "left": ""
    }
  }, [_c('mobile-identity-header', {
    attrs: {
      "username": _vm.userName
    }
  }), _vm._v(" "), _c('mobile-menu-container', [_c('mobile-menu-section-list-item', {
    staticClass: "profileInformationContainer",
    attrs: {
      "labelId": "leftPanelTitle.my_prfl"
    },
    on: {
      "click": function($event) {
        return _vm.goToLink('/profile/')
      }
    }
  }), _vm._v(" "), _c('mobile-menu-section-list-item', {
    staticClass: "profileInformationContainer",
    attrs: {
      "labelId": "leftPanelTitle.swtch_prfl"
    },
    on: {
      "click": _vm.activateModalProfile
    }
  }), _vm._v(" "), _c('mobile-menu-section-list-item', {
    staticClass: "profileInformationContainer",
    attrs: {
      "labelId": "Webheader.settings"
    },
    on: {
      "click": function($event) {
        return _vm.goToLink('/settings/application/')
      }
    }
  }), _vm._v(" "), (this.accountType === '1') ? _c('mobile-menu-section-list-item', {
    staticClass: "profileInformationContainer",
    attrs: {
      "labelId": "Webheader.company_members"
    },
    on: {
      "click": function($event) {
        return _vm.goToLink('/accountMembers/')
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('mobile-menu-section-list-item', {
    staticClass: "profileInformationContainer",
    attrs: {
      "labelId": "leftPanelTitle.lgout"
    },
    on: {
      "click": _vm.logoutWait
    }
  })], 1), _vm._v(" "), _c('mobile-menu-container', _vm._l((_vm.menu), function(item) {
    return (!_vm.isDisabledItem(item)) ? _c('mobile-menu-section', {
      key: item.id,
      attrs: {
        "headerLabelId": item.title
      }
    }, [(item.list) ? _c('div', _vm._l((item.list), function(subItem) {
      return (subItem.id !== 0 && subItem.enabled) ? _c('mobile-menu-section-list-item', {
        key: subItem.id,
        attrs: {
          "labelId": subItem.titleShort,
          "disabled": _vm.isDisabledItem(subItem)
        },
        on: {
          "click": function($event) {
            return _vm.getClicked(subItem)
          }
        }
      }) : _vm._e()
    }), 1) : (item.link) ? _c('div', [_c('mobile-menu-section-list-item', {
      attrs: {
        "labelId": item.titleShort,
        "disabled": _vm.isDisabledItem(item)
      },
      on: {
        "click": function($event) {
          return _vm.getClicked(item)
        }
      }
    })], 1) : _vm._e()]) : _vm._e()
  }), 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9181714e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9181714e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menus/MobileLeftPanel.vue
// module id = 2422
// module chunks = 2